import Block from './Block'
import gsap from 'gsap';

export default class SliderBlockProjects extends Block {
  onEnterCompleted() {
    this.createSlider();
  }

  getElems() {
    this.sliderContainer = this.el;
  }

  createSlider() {
    const inner = this.sliderContainer.querySelector(".slider-inner");
    const cards = this.sliderContainer.querySelector(".projects");
    const containerWidth = window.innerWidth;

    // Recalcule la largeur de l'ensemble cards
    const cardsWidth = cards.scrollWidth;

    // Nettoie tout contenu cloné précédent
    inner.innerHTML = '';
    inner.appendChild(cards);

    // Crée des duplications basées sur la largeur de la fenêtre
    const numDuplicates = Math.ceil(containerWidth / (cardsWidth)) + 2;

    for (let i = 0; i < numDuplicates; i++) {
      const clone = cards.cloneNode(true);
      inner.appendChild(clone);
    }

    this.arrows();

    // Initialise l'animation avec la nouvelle largeur
    gsap.to(inner.querySelectorAll(".projects"), {
      x: `-=${cardsWidth}`,
      duration: cardsWidth / 80,
      overwrite: "true",
      ease: "none",
      repeat: -1,
    });
  }

  arrows() {
    this.cards = this.sliderContainer.querySelectorAll(".card-project");
    this.cards.forEach( (card) => {
      const arrow = card.querySelector(".card-project__arrow");

      if (arrow) {
        // Configuration de base pour les animations
        const btnConfig = {duration: 0.45, ease: "power2.out"};

        // Création des fonctions quickTo avec des configurations distinctes
        const moveBtnPosition = {
          top: gsap.quickTo(arrow, "top", btnConfig),
          left: gsap.quickTo(arrow, "left", btnConfig)
        };

        // Animations standards pour les autres propriétés
        card.addEventListener("mouseenter", (e) => {
          const blockOffset = card.getBoundingClientRect();

          // Animation de l'apparition
          gsap.to(arrow, {
            opacity: 1,
            duration: 0.3
          });

          // Positionnement initial
          moveBtnPosition.top(e.clientY - blockOffset.top);
          moveBtnPosition.left(e.clientX - blockOffset.left);
        });

        card.addEventListener("mousemove", (e) => {
          const blockOffset = card.getBoundingClientRect();
          moveBtnPosition.top(e.clientY - blockOffset.top);
          moveBtnPosition.left(e.clientX - blockOffset.left);
        });

        card.addEventListener("mouseleave", () => {
          gsap.to(arrow, {
            opacity: 0,
            duration: 0.3
          });
        });
      }
    });
  }

  resize() {
    this.createSlider()
  }
}
